import { Routes, Route, Navigate } from "react-router-dom";
import React, { Suspense } from "react";
import RoleGuard from "./components/guards/RoleGuard";
import { lazy } from "react";

const Posts = lazy(() => import("./components/Posts"));
const PostEditor = lazy(() => import("./components/PostEditor"));
const AdminUser = lazy(() => import("./components/admin/AdminUser"));
const AdminEmail = lazy(() => import("./components/admin/AdminEmail"));
const AdminLog = lazy(() => import("./components/admin/AdminLog"));
const Counters = lazy(() => import("./components/Counters"));
const CounterStats = lazy(() => import("./components/CounterStats"));
const StatsOverview = lazy(() => import("./components/StatsOverview"));
const NotFoundPage = lazy(() => import("./components/NotFoundPage"));
const Settings = lazy(() => import("./components/Settings"));

export function LoggedInRouter() {
  const routes = [
    {
      path: "/",
      element: <Counters />,
    },
    {
      path: "/stats",
      element: <StatsOverview />,
    },
    {
      path: "/stats/:id",
      element: <CounterStats />,
    },
    {
      path: "/settings",
      element: <Settings />,
    },
    {
      path: "/posts",
      element: (
        <RoleGuard roles={["admin", "user"]}>
          <Posts />
        </RoleGuard>
      ),
    },
    {
      path: "/posts/new",
      element: (
        <RoleGuard roles={["admin", "user"]}>
          <PostEditor />
        </RoleGuard>
      ),
    },
    {
      path: "/posts/edit/:id",
      element: (
        <RoleGuard roles={["admin", "user"]}>
          <PostEditor />
        </RoleGuard>
      ),
    },
    {
      path: "/admin/users",
      element: (
        <RoleGuard roles={["admin"]}>
          <AdminUser />
        </RoleGuard>
      ),
    },
    {
      path: "/admin/email",
      element: (
        <RoleGuard roles={["admin"]}>
          <AdminEmail />
        </RoleGuard>
      ),
    },
    {
      path: "/admin/log",
      element: (
        <RoleGuard roles={["admin"]}>
          <AdminLog />
        </RoleGuard>
      ),
    },
    {
      path: "/admin",
      element: (
        <RoleGuard roles={["admin"]}>
          <Navigate to="/admin/users" replace />
        </RoleGuard>
      ),
    },
    {
      path: "*",
      element: <NotFoundPage />,
    },
  ];

  return (
    <Suspense fallback={<div />}> 
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
    </Suspense>
  );
}
